import { useEffect, useMemo } from 'react'

import {
  getDefaultWalletPermissions,
  getStaticWalletPermissions,
} from '@/config/permissions/staticWalletPermissions'
import { syncWalletPermissionsFromApi } from '@/config/walletPermissions'
import type { WalletPermissionsEffective } from '@/data/marketApi/types'
import { useAppWeb3 } from '@/hooks'

/**
 * Permisos efectivos de la wallet conectada (Expert Mode, rutas internas).
 * Fuente: static product allowlist (Market API permissions retired).
 */
export function useWalletPermissions(): {
  permissions: WalletPermissionsEffective
  isLoading: boolean
  isFromApi: boolean
} {
  const { account } = useAppWeb3()

  const permissions = useMemo(() => {
    if (!account) return getDefaultWalletPermissions()
    return getStaticWalletPermissions(account)
  }, [account])

  useEffect(() => {
    syncWalletPermissionsFromApi(permissions)
  }, [permissions])

  return {
    permissions,
    isLoading: false,
    isFromApi: false,
  }
}
